import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_book_ext_RowClass} from '../../../dbschema/bl_fi_mst_price_book_ext.model';

export class PriceBookExtensionContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_ext: bl_fi_mst_price_book_ext_RowClass = new bl_fi_mst_price_book_ext_RowClass();
}
